<template>
  <div class="col-12 turma-card-container">
    <div class="turma-card-infos">
      <strong>
        <i class="fa fa-book fa-2x"></i>
      </strong>

      <span>{{ getData() }}</span>
    </div>

    <button v-if="isButtonDisabled" class="turma-card-button blocked" disabled>
      <template v-if="classIsFinished">
        A aula não está mais disponível.
      </template>

      <template v-else>
        Disponível às {{ formatTime(turma.data_inicio) }}
      </template>
      <i class="fa fa-lock fa-lg"></i>
    </button>

    <template v-else>
      <button class="turma-card-button able justify-content-center" v-if="loading" disabled>
        <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="24"></component>
      </button>

      <button class="turma-card-button able" v-else @click="watchClassClick">
        Assistir aula
        <i class="fa fa-arrow-right fa-lg"></i>
      </button>
    </template>

    <!-- <div>
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="card-title fa fa-book fa-2x" :style="titleStyle">

          <strong style="font-size: 19px; padding-left: 3px; font-family: Arial, Helvetica, sans-serif;">{{
            turma.materia }}</strong>
        </h4>
        <div :style="dateStyle" class="d-inline-flex aligned-text">
          {{ getData() }}
        </div>
      </div>
      <div class="text-center mt-3 form-group">
        <a v-if="aulaDisponivel" href="#" style="color: black;" class="btn btn-primary btn-lg col-12"
          @click="watchClassClick">
          Assistir aula<i class="fa fa-arrow-right" style="padding-left: 10px;"></i>
        </a>
        <a v-else href="#" style="color: black; padding-bottom: 40px; " class="btn-lg col-12 form-control"
          :class="{ 'disabled-button': isButtonDisabled }">
          Disponível às {{ formatTime(turma.data_inicio) }}h <i class="fa fa-lock" style="padding-left: 10px;"></i>
        </a>
      </div>
    </div> -->
  </div>
</template>

<script>
import * as spinners from 'epic-spinners'

export default {
  props: {
    turma: Object,
    agora: Date,
    isButtonDisabled: Boolean,
    loading: Boolean,
    classIsFinished: Boolean
  },
  components: {
    ...spinners,
  },
  computed: {
    // cardStyle() {
    //   return {
    //     borderRadius: '15px',
    //     width: '600px',
    //     //  height: '150px',
    //     marginTop: '5%',
    //   }
    // },
    // cardBodyStyle() {
    //   return {
    //     marginLeft: '2%',
    //   }
    // },
    // titleStyle() {
    //   return {
    //     color: 'black',
    //   }
    // },
    // dateStyle() {
    //   return {
    //     marginLeft: '5%',
    //     paddingLeft: '1%',
    //     paddingRight: '1%',
    //     color: 'white',
    //     backgroundColor: '#1E2F5B',
    //     borderRadius: '50px',
    //   }
    // },
  },
  methods: {
    watchClassClick() {
      this.$emit('watch-class-click', this.turma)
    },
    formatDate(date) {
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
    },
    formatTime(date) {
      const hours = date.getHours()
      const minutes = date.getMinutes()
      return ` ${hours}:${minutes < 10 ? '0' + minutes : minutes}`
    },
    getData() {
      let text = this.agora.toDateString() === this.turma.data_inicio.toDateString() ? 'Hoje, ' : this.formatDate(this.turma.data_inicio)
      return text += `${this.formatTime(this.turma.data_inicio)}  -  ${this.formatTime(this.turma.data_fim)}`
    },
  },
}
</script>

<style scoped>
.disabled-button {
  background-color: gray;
  cursor: not-allowed;
}

.turma-card-container {
  border: 1px solid #CACACA;
  border-radius: 12px;

  padding: 2rem 1rem;

  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.turma-card-infos {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.turma-card-infos>strong {
  display: flex;
  align-items: center;
  gap: 0.5rem;

  color: #0F0E0E;
  font-size: 1.25rem;
  font-weight: 700;
}

.turma-card-infos>span {
  padding: 0.25rem 1rem;
  background: #1E2F5B;
  border: 0;
  border-radius: 24px;

  color: #FFF;
}

.turma-card-button {
  padding: 1.5rem 0.75rem;
  border: 0;
  border-radius: 4px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  color: #0F0E0E;
  font-size: 1rem;
  font-weight: 700;
}

.turma-card-button.able {
  background: #FABF10;
}

.turma-card-button.blocked {
  background: #CACACA;
  cursor: not-allowed;
}
</style>
